import { render, staticRenderFns } from "./describeimage.vue?vue&type=template&id=09253698&scoped=true&"
import script from "./describeimage.vue?vue&type=script&lang=js&"
export * from "./describeimage.vue?vue&type=script&lang=js&"
import style0 from "./describeimage.vue?vue&type=style&index=0&id=09253698&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09253698",
  null
  
)

export default component.exports